<script lang="ts" module>
	import heroImageXs from "@assets/images/gift-subscription-hero.jpg?webp&h=1000&quality=95&imagetools";
	import heroImageSm from "@assets/images/gift-subscription-hero.jpg?webp&h=1300&quality=95&imagetools";
	import heroImageLg from "@assets/images/gift-subscription-hero.jpg?webp&h=1600&imagetools";
	import heroImageXl from "@assets/images/gift-subscription-hero.jpg?webp&h=1900&imagetools";
	import heroImage3xl from "@assets/images/gift-subscription-hero.jpg?webp&imagetools";
	import giftSubscriptionLogoCs from "@assets/images/gift-subscription-logo-cs.png?webp&w=900&imagetools";
	import giftSubscriptionLogoEn from "@assets/images/gift-subscription-logo-en.png?webp&w=900&imagetools";
	import Heading from "@components/common/Heading.svelte";
	import Media from "@components/common/Media.svelte";
	import ImageSection from "@components/sections/ImageSection.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import type { Snippet } from "svelte";
	import type { ClassValue } from "svelte/elements";
	import { Locale, type LocalizedString } from "@core/schema/Locale.js";
	import { tw } from "@core/utils/svelte/tw.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import translations from "./GiftSubscriptionHero.translations.json" with { type: "json" };

	const iphoneSafePaddingBottom = tw("pb-[max(env(safe-area-inset-bottom,0),0.5rem)]");
	const heroImageHeight = tw("!h-[max(calc(100vh-8rem),32rem)]");
	const logoLocaleMap: LocalizedString = {
		[Locale.cs]: giftSubscriptionLogoCs,
		[Locale.en]: giftSubscriptionLogoEn,
	};
</script>

<script lang="ts">
	const { children, class: customClass }: { children: Snippet; class?: ClassValue } = $props();
	const { tenant } = getGlobalTemplateProps();
	const translate = getTranslate(translations);
</script>

<ImageSection
	lcp
	sources={{
		default: heroImageXs,
		">sm": heroImageSm,
		">lg": heroImageLg,
		">xl": heroImageXl,
		">3xl": heroImage3xl,
	}}
	darkOverlay
	class={[heroImageHeight, iphoneSafePaddingBottom, customClass]}
	actions={children}
>
	{#snippet heading()}
		<Heading
			level={1}
			text={translate("heroTitle")}
			class="absolute min-w-45 w-3/4 max-w-183 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
		>
			<Media
				width={410}
				height={230}
				sourcesets={{}}
				class="w-full"
				source={{ type: "image/webp", src: logoLocaleMap[tenant.locale] }}
				alt={translate("heroTitle")}
			/>
		</Heading>
	{/snippet}
</ImageSection>
